import {
  CANCELED_CODE,
  isInsightActionErrorCode,
  type InsightActionError,
} from '../models/insightActionError'

import { ApiError } from '@/shared/http'

const UNAVAILABLE = 'INSIGHTS_UNAVAILABLE'

function resolveCode(error: ApiError): string {
  if (error.kind === 'canceled') return CANCELED_CODE
  if (error.code && isInsightActionErrorCode(error.code)) return error.code
  if (error.code) return error.code
  if (error.kind === 'notFound') return 'INSIGHT_NOT_FOUND'
  if (error.kind === 'forbidden') return 'PERMISSION_DENIED'
  return UNAVAILABLE
}

export function classifyInsightActionError(cause: unknown): InsightActionError {
  const error = ApiError.isApiError(cause) ? cause : ApiError.fromAxios(cause)
  const code = resolveCode(error)

  return {
    code,
    detail: error.userVisible ? error.detail : '',
    canceled: code === CANCELED_CODE,
  }
}

export function isCanceled(error: InsightActionError): boolean {
  return error.canceled
}

export function isFlagDisabled(error: InsightActionError): boolean {
  return error.code === 'PLATFORM_ACTIONS_DISABLED'
}

export function isStaleData(error: InsightActionError): boolean {
  return error.code === 'INSIGHT_DATA_STALE'
}
